import Feedback from "../Feedback";
import Footer from "../Footer";
import GlobalNav from "../GlobalNav";
import SideNav from "../SideNav";
// import TableOfContents from "../TableOfContents";
import TopNav from "../TopNav";

export default function Layout(props) {

    // const createHeadings = (items) => {
    //     items.map((item) => {
    //         if (item.type === "heading") {
    //             item.id = item.children[0].value;
    //             item.title = item.children[0].value;
    //         }
    //         return item;
    //     });
    //     return items;
    // };

    return (<>
        <div suppressHydrationWarning={true} className={`top-nav ${"nav-dark-blue"}`}>
            <div className="ready">
                <GlobalNav user={props.user} mobileMenuIsOpen={props.mobileMenuIsOpen} setMobileMenu={props.setMobileMenu} />
            </div>
            <TopNav children={undefined}></TopNav>
        </div>
        <div suppressHydrationWarning={true} id="main-wrapper" className={(props.mobileMenuIsOpen ? " menu-open " : "") + " doc " + " main-wrapper "}>
            <main className={"main"}>
                <SideNav/>
                <div className="inner">
                    {props.children}
                    <Feedback/>
                </div>
                {/* <TableOfContents toc={createHeadings(props.post.content.value.document.children)} blog={props.post} showAuthor={props.post.author}/> */}
            </main>
            <div className="footer-bar">
                <Footer handleToast={props.handleToast} />
            </div>
        </div>
        <style jsx global>{`
            body{
                overflow: hidden;
                overflow-x:hidden;
            }
           
            .nav-divider{
                border-top: 1px solid var(--black-medium);
                border-left:300px solid transparent;
                border-right:300px solid transparent;
                background: var(--covalent-dark-blue);
              }
            .divider-cont{
                overflow:hidden;
                width:100%;

            }
            .top-nav{
                position: sticky;
                width:100%;
                top:0;
                z-index:999;
                backdrop-filter: blur(10px);
                transition-property: all;
                transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
                transition-duration: 150ms;
            }
            .nav-transparent{ 
                background:transparent;
            }
            .nav-dark-blue{
                background: var(--covalent-dark-blue);
            }

            .top-nav:hover{
                background: var(--covalent-dark-blue);
            }

            .main-wrapper {
                overflow-x:hidden;
                max-height: calc(100vh - var(--top-nav-height));
            }
            .inner {
                max-width: 100vw;
            }

            .legacy-header {
                display: grid;
                grid-gap: 24px;
                gap: 24px;
                max-width: 54rem;
                width: 100%;
                min-width: 0;
                padding: 2rem 3rem 0rem 3rem;
                align-items: center;
            }
            @media screen and (max-width: 767px) {
                .legacy-header {
                    padding: 0rem 1rem;
                    margin-top: 1rem;
                }
                .apiref {
                    max-height: calc(100vh - var(--top-nav-height));
                    min-height: 0 !important;
                }
            }
            
            .date {
                font-size: var(--font-size-3);
                margin-top: -1rem;
                color: var(--pink);
            }
            `}</style>
        <style jsx>
            {`
          .page {
            justify-content:center;
            min-height: calc(100vh - var(--top-nav-height));
          }
          .page main {
            display:flex;
          }

          .doc {
            width: 100vw;
            min-height: calc(100vh - var(--top-nav-height));
            max-width: 100%;
            
          }
          .doc main {
            display: flex;
          }

          .blog {
            width: 100%;
          }

          .apiref {
            width: 100vw;
            min-height: calc(100vh - var(--top-nav-height));
            max-width: 100%;
          }

          .page.menu-open {
            overflow: hidden;
            height: 100%;
          }

          .doc.menu-open {
            overflow: hidden;
            height: 100%;
          }

          .dark .page {
            border-bottom-color: var(--black-light);
          }

          .main{
           width: 100%;
          }

          article {
            padding: 2rem 1.5rem 3rem;
            
          }

          .footer-bar {
            flex: 1;
            padding: 0;
            // border-top:  1px solid var(--gray-medium);
          }

        `}
        </style>
    );
    </>);
}